import { ONETRUST_COOKIE_NAME } from '../constants';
import { getCookie } from '../cookies_utils';
import {
  mergeMetaData,
  removePiiEntries,
  removeUnsupportedFullStoryProperties,
  removeUnwantedFullStoryProperties,
} from '../helpers/helper';
import { SnowplowHelper } from '../helpers/snowplow_helper';
import { loadFS, windowFS } from './fullstory_helper';
import WrappedProvider from './wrapped_provider';

export interface IdentifyData {
  userId?: string;
  visitorId?: string;
  sessionId?: string;
  data?: Record<string, any>;
}

export interface TrackData {
  data?: Record<string, any>;
  eventCategory: string;
  eventName: string;
  sessionId?: string;
  userId?: string;
  visitorId?: string;
}

const PII_KEYWORDS = ['name', 'phone', 'email', 'ssn'];
const ALLOW_KEYWORDS = ['experiment_name', 'variation_name', 'element_name', 'parent_name'];
class FullstoryProvider extends WrappedProvider {
  static configKey: string = 'fullstory';
  static isApprovedProvider: boolean = false;
  static providerName: string = 'Fullstory';

  load(snowplowHelper: SnowplowHelper) {
    // Loading OneTrust Consent Information from Cookie
    const onetrustConsentInformation = snowplowHelper.addOnetrustCookies(
      getCookie(ONETRUST_COOKIE_NAME),
    );
    // Based on the schema for consent information in this file: ../../optanon_consent_cookies.json
    // We check if user has opted in for performance cookies before loading fullstory

    if (onetrustConsentInformation && onetrustConsentInformation.performance_cookies === 'opt_in') {
      loadFS(this.config.fs_org);
    } else {
      if (!onetrustConsentInformation) {
        console.error('[ERROR] Missing consent information');
      }
    }

    // We are adding a log statement to put the value of onetrustConsentInformation as well to make sure we are parsing cookies correctly and cookie is available
    globalThis.console.log(
      'Privacy Consent Information from Cookie Banner: ',
      onetrustConsentInformation,
    );
  }

  identify({ userId, visitorId, sessionId, data }: IdentifyData) {
    const fsData = mergeMetaData({ userId, visitorId, sessionId, data });
    let filteredFsData = removePiiEntries(fsData, PII_KEYWORDS, ALLOW_KEYWORDS);
    filteredFsData = removeUnsupportedFullStoryProperties(filteredFsData);
    if (userId) {
      windowFS('identify', userId, filteredFsData);
    } else {
      windowFS('setUserVars', filteredFsData);
    }
  }

  track({ data, eventCategory, eventName, sessionId, userId, visitorId }: TrackData): void {
    const fsData = mergeMetaData({ userId, visitorId, sessionId, data });
    let filteredFsData = removePiiEntries(fsData, PII_KEYWORDS, ALLOW_KEYWORDS);
    filteredFsData = removeUnsupportedFullStoryProperties(filteredFsData);
    filteredFsData = removeUnwantedFullStoryProperties(filteredFsData);
    windowFS('event', `${eventCategory}${eventName}`, filteredFsData);
  }

  page() {}

  group() {}
}

export default FullstoryProvider;
